import React, { useState, useEffect, useMemo } from 'react';
import { Grid, Paper } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import moment from 'moment';
import { liveTrackinglayoutSelector } from '../../../features/layout/layoutSlice';
import { useSelector } from 'react-redux';
//import { UPlot } from "react-uplot";
import { Line } from 'react-chartjs-2';
//import * as ChartAnnotation from 'chartjs-plugin-annotation';
import { useTable } from 'react-table';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useTheme } from '@mui/material/styles';

import { Chart } from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';
import { renderAddressMapLink } from './reportMapLinks';
Chart.register(annotationPlugin);

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: 'Silver',
        color: useTheme().palette.common.black,
        fontSize: 13,
        fontStyle: 'bold'
    },
    body: {
        fontSize: 13,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: useTheme().palette.action.hover,
        },
    },
}))(TableRow);


const plotOptions = (speedLimit) => {
    return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                dispay: true,
                position: 'bottom',
                labels: {
                    fontSize: 12,
                    fontStyle: 'bold'
                }
            },
            annotation: {
                annotations: {
                    line1: {
                        type: 'line',
                        yMin: parseInt(speedLimit),
                        yMax: parseInt(speedLimit),
                        borderColor: 'Red',
                        borderWidth: 1,
                        label: {
                            backgroundColor: 'red',
                            content: `Speed Limit: ${speedLimit} Km/h`,
                            enabled: true,
                        },
                    }
                }
            }

        },
        animation: { duration: 0 },
        elements: {
            point: {
                radius: 0
            }
        },
    }
};


const Overspeed = ({ reportData }) => {
    const dimentions = useSelector(liveTrackinglayoutSelector);

    const [plotData, setPlotData] = useState(null);
    const [plotAvailable, setPlotAvailable] = useState(false);
    useEffect(() => {
        if (reportData && reportData.track && reportData.track.length > 0 && reportData.track.length < 5000) {
            let pdata = [];
            reportData.track.forEach(p => {
                pdata.push({ x: p.dt_tracker, y: p.speed });
            })
            setPlotData({
                datasets: [{
                    label: 'Speed Profile',
                    data: pdata,
                    fill: false,
                    borderColor: 'DodgerBlue',
                    backgroundColor: 'DodgerBlue',
                    borderWidth: 1,
                    pointRadius: 0,
                }],
            });
            setPlotAvailable(true);

        }
    }, [reportData]);
    /* useEffect(() => {
        console.log("report Data", reportData);
    }, [reportData]); */

    const tableData = useMemo(() => {
        if (reportData.reportRecords && reportData.reportRecords.length > 0) {
            return reportData.reportRecords.map(item => {
                return {
                    start: moment(item.startTime).format('D/M/Y hh:mm A'),
                    end: moment(item.endTime).format('D/M/Y hh:mm A'),
                    duration: item.duration,
                    topSpeed: `${item.topSpeed.toFixed(0)} Km/h`,
                    location: renderAddressMapLink({
                        address: item.address,
                        fallback: 'N/A',
                        lat: item.lat,
                        lng: item.lng,
                        source: item,
                    }),
                    key: item.startTime,
                };
            })
        } else {
            return [];
        }

    }, [reportData]);

    const tableColumns = useMemo(() => {
        return [
            { Header: 'Start', accessor: 'start' },
            { Header: 'End', accessor: 'end' },
            { Header: 'Duration', accessor: 'duration' },
            { Header: 'Top Speed', accessor: 'topSpeed' },
            { Header: 'Location', accessor: 'location' },
        ];
    }, []);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({ columns: tableColumns, data: tableData });



    if (reportData && reportData.track && reportData.track.length > 0 && reportData.reportRecords && reportData.reportRecords.length > 0) {
    return (
        <Paper style={{ ...dimentions.reportDetailViewBottom, overflow: 'auto' }}>
            <div style={{ margin: '10px', marginRight: '5px' }}>
                <Grid container spacing={1}>
                    {
                        plotAvailable &&
                        <Grid item container sm={12}>
                            <Line
                                data={plotData}
                                options={plotOptions(reportData.speedLimit)}
                                height={400}
                            />
                        </Grid>
                    }
                    <Grid item sm={12} container>
                        <TableContainer component={Paper}>
                            <Table  {...getTableProps()}>
                                <TableHead>
                                    {headerGroups.map(headerGroup => (
                                        <TableRow {...headerGroup.getHeaderGroupProps()}>
                                            {headerGroup.headers.map(column => (
                                                <StyledTableCell
                                                    {...column.getHeaderProps()}
                                                >
                                                    <b>{column.render('Header')}</b>
                                                </StyledTableCell>
                                            ))}
                                        </TableRow>
                                    ))}
                                </TableHead>
                                <TableBody {...getTableBodyProps()}>
                                    {rows.map((row) => {
                                        prepareRow(row)
                                        return (
                                            <StyledTableRow {...row.getRowProps()}>
                                                {row.cells.map(cell => {
                                                    return (
                                                        <StyledTableCell
                                                            {...cell.getCellProps()}
                                                        >
                                                            {cell.render('Cell')}
                                                        </StyledTableCell>
                                                    )
                                                })}
                                            </StyledTableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>

                </Grid>
            </div>
        </Paper>
    );
    } else {
        return null;
    }
}

export default Overspeed;

/*
<UPlot
                                options={{
                                    height: 400,
                                    width: dimentions.content.widthpx,
                                    series: [
                                        {},
                                        {
                                            stroke: "DodgerBlue",
                                            label: "Speed",
                                            fill: "LightBlue",
                                            value: (self, rawValue) => rawValue.toFixed(0) + " Km/h",
                                        },
                                        {
                                            stroke: "red",
                                            label: "Limit",
                                            value: (self, rawValue) => rawValue.toFixed(0) + " Km/h",
                                        }
                                    ]
                                }}
                                data={reportData.speedPlot}
                            />
*/
